import axios, { AxiosRequestConfig } from 'axios'

import campaign from './campaign'
import connect from './connect'
import social from './customer-social'
import matrix from './matrix'
import otp from './otp'
import pdpa from './pdpa'
import ptp from './promise-to-pay'

type APIVersion = 'v1' | 'v2'

function getBaseUrl(apiVersion: APIVersion) {
    switch (apiVersion) {
        case 'v1':
            return process.env.THUNDER_CONNECT_API
        case 'v2':
            return process.env.THUNDER_CONNECT_API_V2
        default:
            return process.env.THUNDER_CONNECT_API
    }
}

function getAPI(opts?: AxiosRequestConfig, apiVersion: APIVersion = 'v1') {
    const api = axios.create({
        baseURL: getBaseUrl(apiVersion),
        timeout: 10000,
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': 'GdyJaafDS05luL0LZS8RI6AFtDskoRRD3tx90r1v',
            Authorization: `Bearer ${window.sessionStorage.getItem('accessToken')}`,
        },
        ...opts,
    })

    return {
        otpService: otp(api),
        socialService: social(api),
        ptpService: ptp(api),
        pdpaService: pdpa(api),
        campaignService: campaign(api),
        connectService: connect(api),
    }
}

export const analyticService = matrix

export default getAPI
